import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useValidateEmail from "src/welcomeNonGemi/data-access/useValidateEmail";
import { Box, CircularProgress, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

function ValidateEmail() {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { status: status, isLoading: isLoading } = useValidateEmail({
    token: searchParams.get("t"),
  });

  return (
    <Box sx={{ width: "100%" }}>
      {isLoading ? (
        <CircularProgress />
      ) : status == "success" ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            maxWidth: "80vw",
            mx: "auto",
          }}
        >
          <Typography variant="h4" component="h1">
            {t("Η εγγραφή σας ολοκληρώθηκε με επιτυχία")}
          </Typography>
          <Typography variant="h6" component="h2">
            {t(
              "Καλωσήρθατε στο σύστημα. Ο λογαριασμός σας ενεργοποιήθηκε με επιτυχία",
            )}
          </Typography>
          <Button
            sx={{ alignSelf: "center" }}
            variant="contained"
            onClick={() => {
              navigate("/welcome/loginForm");
            }}
          >
            {t("Μετάβαση στην οθόνη εισόδου")}
          </Button>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "3rem",
            maxWidth: "80vw",
            mx: "auto",
          }}
        >
          <Typography variant="h4" component="h1">
            {t("Δεν ήταν δυνατή η ενεργοποίηση του λογαριασμού")}
          </Typography>
          <Button
            sx={{ alignSelf: "center" }}
            variant="contained"
            onClick={() => {
              navigate("/welcome/loginForm");
            }}
          >
            {t("Μετάβαση στην οθόνη εισόδου")}
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default ValidateEmail;
